import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function UpgradeTriggerModal() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState({
    title: 'Limit reached',
    message: 'Upgrade your plan to continue',
    benefits: ['Unlimited rentals', 'Advanced analytics', 'WhatsApp automation'],
  });

  useEffect(() => {
    const handler = (event) => {
      const detail = event?.detail || {};
      setContent({
        title: detail.title || 'Limit reached',
        message: detail.message || 'Upgrade your plan to continue',
        benefits: Array.isArray(detail.benefits) && detail.benefits.length > 0
          ? detail.benefits
          : ['Unlimited rentals', 'Advanced analytics', 'WhatsApp automation'],
      });
      setOpen(true);
    };

    window.addEventListener('aiviora:upgrade-trigger', handler);
    return () => window.removeEventListener('aiviora:upgrade-trigger', handler);
  }, []);

  if (!open) return null;

  return (
    <div className="upgrade-modal-backdrop">
      <div className="upgrade-modal">
        <h3>{content.title}</h3>
        <p>{content.message}</p>
        <ul className="upgrade-modal-benefits">
          {content.benefits.map((benefit) => (
            <li key={benefit}>{benefit}</li>
          ))}
        </ul>
        <div className="upgrade-modal-actions">
          <button className="btn btn-outline" onClick={() => setOpen(false)}>Close</button>
          <button className="btn btn-primary" onClick={() => navigate('/pricing')}>Upgrade</button>
        </div>
      </div>
    </div>
  );
}
